import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=342ec698&"
import script from "./ChatFooter.vue?vue&type=script&setup=true&lang=js&"
export * from "./ChatFooter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports